import { Theme } from '@stadionhq-v3/core';

export const isObject = <T extends { [key: string]: unknown }>(
  value: unknown
): value is T =>
  typeof value === 'object' &&
  value !== null &&
  !(value instanceof Date) &&
  !(value instanceof RegExp) &&
  !Array.isArray(value);

export const isTheme = (value: unknown): value is Theme =>
  isObject(value) && 'themeId' in value && 'title' in value;
